import React from 'react';
import { BaasicInput, Loader, BaasicCheckbox, BaasicDropdown } from 'core/components';
import { translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const UserEditTemplate = ({
	t,
	userEditViewStore: {
		form,
		loading,
		rootStore,
		getPrinters,
		notification,
		showNotification,
		hasPiiAccess,
		onCheckPiiAccess,
		canSetPii,
		isHavingAPISecret,
		generateApiSecret,
		onCheckEnableEmailNotification,
		canSetEnableEmailNotification,
		enableEmailNotification,
		onUserPhoneChange,
		isSuperAdmin,
		countryDropdownStore,
		roleDropdownStore,
		labelPrinterDropdownStore,
		packingSlipPrinterDropdownStore
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('UPDATEUSER')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="message message--default spc--bottom--sml">
						<span>{t(form.$('userName').label)}: </span>
						<span>{form.$('userName').value.split('-')[0]}</span>
					</div>
					<BaasicInput autoFocus field={form.$('email')} />
					<BaasicDropdown dropdownStore={countryDropdownStore} />
					<BaasicInput field={form.$('userPhone')} onKeyUp={onUserPhoneChange(form.$('userPhone').value)} />
					<BaasicDropdown
						dropdownStore={roleDropdownStore}
						isDisabled={form.$('id').value == rootStore.authStore.user.id && !isSuperAdmin}
					/>

					<div className="flex--primary flex--align--bottom spc--bottom--sml">
						<div className="flex--grow--1 spc--right--sml">
							<BaasicInput field={form.$('apiKey')} className="fs-mask" />
						</div>
						<button
							className="btn btn--med btn--secondary spc--bottom--sml"
							type="button"
							disabled={loading}
							onClick={getPrinters}
							data-cy="get-printers-button"
						>
							{t('LOGINFORM.PRINTNODE.GETPRINTERS')}
						</button>
					</div>
					{showNotification && (
						<div className="spc--bottom--sml">
							<p className="type--color--warning">{t(notification)}</p>
						</div>
					)}
					<div className="spc--bottom--sml">
						<BaasicDropdown dropdownStore={labelPrinterDropdownStore} isClearable={true} />
					</div>
					<div className="spc--bottom--sml">
						<BaasicDropdown dropdownStore={packingSlipPrinterDropdownStore} isClearable={true} />
					</div>
					<div className="inputgroup">
						<div className="inputgroup--main">
							<BaasicInput field={form.$('apiSecret')} className="fs-mask" disabled />
						</div>
						<div className="inputgroup--aside align--v--bottom">
							{!isHavingAPISecret ? (
								<button
									className="btn btn--med btn--secondary spc--bottom--sml spc--left--sml"
									type="button"
									onClick={generateApiSecret}
									data-cy="generate-api-secret-button"
								>
									{t('LOGINFORM.GENERATEAPISECRET')}
								</button>
							) : null}
						</div>
						{showNotification && <p className="type--color--warning spc--bottom--sml">{t(notification)}</p>}
					</div>
					<div className="spc--bottom--sml">
						<BaasicCheckbox
							id="pii-access"
							onChangeCallback={onCheckPiiAccess}
							label={'LOGINFORM.PIIACCESS'}
							checked={hasPiiAccess}
							disabled={!canSetPii}
						/>
					</div>
					{canSetEnableEmailNotification &&
						_.find(roleDropdownStore.options.slice(), role => {
							return role.label == 'Warehouse Administrator' || role.label == 'Warehouse Account Owner';
						}) && (
							<div className="spc--bottom--sml">
								<BaasicCheckbox
									id="enable-email-notification"
									onChangeCallback={onCheckEnableEmailNotification}
									label={'USEREDIT.EMAILNOTIFICATION'}
									checked={enableEmailNotification}
								/>
							</div>
						)}
					{form.error && (
						<div>
							<p className="type--color--warning">{translate(form.error)}</p>
						</div>
					)}
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="submit"
						disabled={loading}
						data-cy="save-button"
					>
						{loading ? (
							<div className="spinnercont spc--right--sml">
								<div className="spinner"></div>
							</div>
						) : null}
						{t('SAVE')}
					</button>
				</div>
			</form>
		</React.Fragment>
	);
};

export default defaultTemplate(UserEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/user/pages/UserEditTemplate.jsx